import { useEffect } from "react";
import { useAtom } from "jotai";
import SeccionService from "services/SeccionService";
import { proyectosAtom } from "../store/SeguimientoContratoStore";
import { useContext } from "react";
import { SecurityContext } from "../../../../../../context/SecurityContextProvider";

const useListarProyectos=()=>{
    const { getUsuarioAutenticado } = useContext(SecurityContext);
    const [proyectos, setProyectos] = useAtom(proyectosAtom);
    useEffect(() => {
        const cargarDatos = async () => {
            const respuesta = await SeccionService.listarPorNombreSede(getUsuarioAutenticado().empresaSeleccionada.id, "PROYECTOS");
            setProyectos(respuesta);
        };
        cargarDatos();
    }, []);

    return { proyectos, setProyectos};

}
export default useListarProyectos;
